<template lang="pug">
  utility-truncate.pt-4(
    v-if="description"
    :line-count="5") {{ description }}
    template(v-if="href && !isUserBlocked")
      br
      a(
        target="_blank"
        :href="href") {{ link }}
</template>

<script>
import { computed } from '@vue/composition-api'
import UtilityTruncate from '@iez/components/utility/truncate/'
import { injectRouteState } from '@iez/core'
import isUserBlocked from '@/shared/is-user-blocked/'

export default {
  components: {
    UtilityTruncate
  },

  setup () {
    const routeState = injectRouteState()
    const link = computed(() => routeState.user?.link)
    const href = computed(
      () => link.value
        ? link.value.startsWith(`http`)
          ? link.value
          : `//${link.value}`
        : null
    )

    return {
      description: computed(() => routeState.user?.description),
      href,
      link,
      isUserBlocked
    }
  }
}
</script>
